var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    width: 10.968,
    height: 19.355
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Nav-/-User-[draft]-inverted",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Undo-Redo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "rotate(-90 32 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.599,
    cy: 9,
    stroke: "#FFF",
    strokeWidth: 2,
    mask: "url(#mask-2)",
    rx: 7.707,
    ry: 8
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    cx: 15.23,
    cy: 9.688,
    stroke: "#FFF",
    strokeWidth: 2,
    rx: 4.516,
    ry: 4.688
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23.0434783 41.5217391L23.0434783 41M39.0434783 41.5217391L39.0434783 41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.5a65d5b5775cbe6ce3393cb4ad9dc9b9.svg";
export { ForwardRef as ReactComponent };